import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../Context";
import Navbar from "../../../components/Navbar";
import ServerCard from "../../../components/ServerCard";

const Profile = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const context = useContext(Context);
  const discordBotInviteURL = context.urls.discordBotInviteURL;
  const user = context.user;
  const accessToken = context.accessToken;
  const discordAccessToken = context.session?.provider_token;

  const navigate = useNavigate();
  const [servers, setServers] = useState(null); // This default state of null matters, don't change

  useEffect(() => {
    if (!accessToken || !discordAccessToken) return; // Wait until tokens are available

    // Get user data from API
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiBaseUrl}/api/servers`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`, // Supabase JWT in header
          },
          body: JSON.stringify({ discord_access_token: discordAccessToken }),
        });
        if (response.status === 401) navigate("/"); // If 401 (token invalid), redirect to home page
        const serversData = await response.json();

        // Ensure data is in array format (successful api call) before setting state
        // This check is only necessary because discord api rate limiting
        if (!Array.isArray(serversData))
          console.error("Unexpected data format", serversData);
        setServers(serversData);
      } catch (error) {
        console.error("Failed to fetch servers data", error);
      }
    };

    fetchData();
  }, [apiBaseUrl, navigate, accessToken, discordAccessToken]);

  return (
    <>
      <Navbar />
      <div className="flex flex-col w-4/5 m-auto mt-5 mb-4">
        {user && (
          <div className="flex flex-col mt-8">
            <img
              className="w-48 rounded-full border-2 border-black"
              src={
                user.avatar
                  ? user.avatar
                  : require("../../../images/discord_default_pfp.png")
              }
              alt="Profile Pic"
            />
            <h3 className="text-3xl font-medium">{user.global_name}</h3>
            <h3 className="-mt-1">{user.username}</h3>
          </div>
        )}

        <h1 className="text-5xl mt-8 mb-6">Servers</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4">
          {servers &&
            servers.map((server) => {
              return (
                <ServerCard
                  key={server.id}
                  serverId={server.id}
                  serverName={server.name}
                  icon={server.icon}
                  onClick={() =>
                    navigate(`/user/servers/${server.id}`, {
                      state: { serverData: server },
                    })
                  }
                />
              );
            })}
        </div>

        {/* This will display while loading the data */}
        {!servers && (
          <div className="h-72 rounded-lg bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 bg-[length:200%_200%] animate-gradient-move"></div>
        )}

        {/* This will display if there are no servers found */}
        {servers?.length === 0 && (
          <div className="flex flex-col">
            <h3 className="text-xl mb-4">
              It doesn't appear that you're in any servers with the Fishcord
              bot!
            </h3>
            <a href={discordBotInviteURL} target="_blank" rel="noopener noreferrer">
              <button className="p-4 text-xl rounded-lg border bg-black text-primaryColor hover:bg-secondaryColor hover:text-black hover:border-black hover:rounded-none duration-300">
                Add to Server
              </button>
            </a>
          </div>
        )}
      </div>
    </>
  );
};

export default Profile;
